import React from 'react'
import moment from 'moment'
import { BaseDisplayItemProps } from '../BaseDisplayItem'
import {
    BaseDateField,
    DateFieldItem,
    DateFieldValue,
    normalizeDateFieldValue,
    serializeDateValue,
} from '../shared/date'
import { DateFieldEdit } from './DateFieldEdit'
import { DateFieldSearch } from './DateFieldSearch'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface DateFieldProps
    extends BaseDisplayItemProps<DateFieldValue, DateFieldItem> {}

class DateField extends BaseDateField {
    constructor(props: DateFieldProps) {
        super(props, 'date')
    }

    componentDidUpdate(prevProps: DateFieldProps) {
        super.componentDidUpdate(prevProps)

        if (prevProps.value !== this.props.value) {
            const normalizedValue = normalizeDateFieldValue(this.props.value)
            if (normalizedValue !== this.state.value) {
                this.setState({ value: normalizedValue })
            }
        }
    }

    protected serializeValue(m: moment.Moment): string {
        return serializeDateValue(m)
    }

    renderEdit(): React.ReactNode {
        return (
            <DateFieldEdit
                state={this.state}
                errors={this.props.errors}
                value={this.state.value}
                onChangeDate={this.onChangeDate}
                isInvalid={this.isInvalid}
                getErrorText={this.getErrorText}
                getCurrentLocale={this.getCurrentLocale}
            />
        )
    }

    renderSearch(): React.ReactNode {
        return (
            <DateFieldSearch
                kedo={this.kedo}
                date1={this.state.date1}
                date2={this.state.date2}
                searchType={this.state.searchType}
                show_slider={this.state.show_slider}
                onChangeSearch={this.onChangeSearch}
                onChangeDate={this.onChangeDate}
                isInvalid={this.isInvalid}
                getErrorText={this.getErrorText}
            />
        )
    }
}

export default DateField
